module.exports = __webpack_public_path__ + "static/media/payment_species.26972b10.svg";